'use client';

import { INTAKE_PLACEHOLDERS } from '../intake-copy';
import { findCountryByIso } from '../countries';
import { IntakeCountryPicker } from './IntakeCountryPicker';
import { useWidgetI18n } from '../../../i18n/WidgetI18nProvider';

type Props = {
  value: string;
  detectedIso: string | null;
  error?: string;
  errorId?: string;
  onChange: (iso2: string) => void;
  onBlur: () => void;
};

/** Phone country-code picker (ISO + dial code) built on the shared country picker. */
export function IntakeDialCodeField({
  value,
  detectedIso,
  error,
  errorId,
  onChange,
  onBlur,
}: Props) {
  const { t } = useWidgetI18n();
  const countryCodeLabel = t('intake.countryCode');
  const selected = findCountryByIso(value);
  // "Country code: Canada, +1": the visible "CA +1" alone does not say what it is.
  const accessibleName = selected
    ? t('intake.countryCodeButton', {
        country: selected.name,
        dialCode: selected.dialCode,
      })
    : countryCodeLabel;

  return (
    <IntakeCountryPicker
      mode="dial"
      id="intake-phone-country"
      listId="intake-phone-country-list"
      value={value}
      detectedIso={detectedIso}
      placeholder={INTAKE_PLACEHOLDERS.dialCode}
      searchPlaceholder="Search country or code"
      searchAriaLabel="Search country or code"
      listAriaLabel={countryCodeLabel}
      accessibleName={accessibleName}
      required
      error={error}
      errorId={errorId}
      onChange={onChange}
      onBlur={onBlur}
    />
  );
}
